export const replacePlusWithSpaces = (text: string) => {
  if(!text) return ""
  return text.split( '+').join(" ")
}